"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentMetadataSchema = exports.ExperimentAbortReason = void 0;
const z = require("zod");
var ExperimentAbortReason;
(function (ExperimentAbortReason) {
    ExperimentAbortReason["MixedConfigFingerprint"] = "mixed_config_fingerprint";
})(ExperimentAbortReason || (exports.ExperimentAbortReason = ExperimentAbortReason = {}));
exports.ExperimentMetadataSchema = z.custom((value) => typeof value === 'object' && value !== null, { message: 'metadata must be an object' });
//# sourceMappingURL=experiment-metadata.js.map